import { c as _c } from "react/compiler-runtime";
import { useIntl } from "react-intl";
type DatePlaceholders = {
  minimum?: Date;
  maximum?: Date;
};
const DATE_PLACEHOLDERS = {
  MINIMUM: "{- minimum, datetime}",
  MAXIMUM: "{- maximum, datetime}"
} as const;
export function useFormattedDatePlaceholders(formatOptions) {
  const $ = _c(3);
  const intl = useIntl();
  let t0;
  if ($[0] !== formatOptions || $[1] !== intl.locale) {
    const formatDate = date => new Intl.DateTimeFormat(intl.locale, formatOptions).format(date);
    t0 = (message, dates) => {
      let result = message;
      if (message.includes(DATE_PLACEHOLDERS.MINIMUM) && dates.minimum) {
        const formattedMin = formatDate(dates.minimum);
        result = result.replace(DATE_PLACEHOLDERS.MINIMUM, formattedMin);
      }
      if (message.includes(DATE_PLACEHOLDERS.MAXIMUM) && dates.maximum) {
        const formattedMax = formatDate(dates.maximum);
        result = result.replace(DATE_PLACEHOLDERS.MAXIMUM, formattedMax);
      }
      return result;
    };
    $[0] = formatOptions;
    $[1] = intl.locale;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}